import React from "react";
import { Button, Modal, Form, Input, Select, Card } from "antd";

import Draggable from "react-draggable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import LiveTrackingStore from "../store/LiveTrackingStore";
import { Icon } from "leaflet";
import L from "leaflet";
import Autocomplete from "react-google-autocomplete";
import config from "../config";

import { CloseOutlined } from "@ant-design/icons";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
const { Option } = Select;

class DraggableModal extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);

    this.state = {
      disabled: false,
      open: true,
      bounds: { left: 0, top: 0, bottom: 0, right: 0 },
      companyId: null,
      vehicleLat: null,
      vehicleLng: null,
      geoLat: null,
      geoLng: null,
      LocationLat: null,
      LocationLong: null,
      distance: null,
      vehicleDisable: false,
      GeoDisable: false,
      LocDisable: false,
      markerShape: [],
      ShapeValue: [],
      formatted_address: "",
      searchBy: false,
      clickOnMapBoolean: true,
    };
    this.formRef = React.createRef();

    this.dragRef = React.createRef();
    this.LiveTrackingStore = new LiveTrackingStore();

    this.handleInput = this.handleInput.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handlePlaceSelected = this.handlePlaceSelected.bind(this);
    this.customIconFunc = this.customIconFunc.bind(this);
  }

  componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.LiveTrackingStore.getVehicleData(
        this.props.getUserData().userCompanyId
      );

      this.setState({ companyId: this.props.getUserData().userCompanyId });
    }
  }

  customIconFunc(data) {
    var customIcon = new Icon({
      iconUrl: this.LiveTrackingStore.getIcon(data),

      iconSize: [21, 52], // size of the icon
    });

    return customIcon;
  }

  handleOk = async () => {
    var map = this.props.mapRef.current;
    if (this.state.ShapeValue.length > 0) {
      this.state.ShapeValue.map((s) => {
        map.removeLayer(s);
      });
    }

    if (this.state.markerShape.length > 0) {
      this.state.markerShape.map((m) => {
        map.removeLayer(m);
      });
    }
    if (
      this.LiveTrackingStore.Marker != undefined &&
      this.LiveTrackingStore.Marker != null &&
      this.LiveTrackingStore.Marker != ""
    ) {
      map.removeLayer(this.LiveTrackingStore.Marker);
    }

    if (this.state.companyId === null) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_ENTER_COMPANY_NAME_"),
      });
    } else if (this.state.searchBy === false && this.state.companyId) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_SEARCH_BY_OPTION_"),
      });
    } else if (
      this.state.searchBy === "vehicle" &&
      this.state.vehicleLat === null &&
      this.state.vehicleLng === null
    ) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_SELECT_VEHICLE_"),
      });
    } else if (
      this.state.searchBy === "geofence" &&
      this.state.geoLat === null &&
      this.state.geoLng == null
    ) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_SELECT_GEOFENCE_"),
      });
    } else if (
      this.state.searchBy === "location" &&
      this.state.LocationLat === null &&
      this.state.LocationLong == null
    ) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_ENTER_LOCATION_"),
      });
    } else if (this.state.searchBy === "map" && this.state.clickOnMapBoolean) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_CLICK_ON_MAP_"),
      });
    } else if (
      this.state.distance === null ||
      (this.state.distance === null &&
        (this.state.geoLat || this.state.LocationLat || this.state.vehicleLat))
    ) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_ADD_DISTANCE_"),
      });
    } else if (
      (this.state.companyId && this.state.vehicleLat) ||
      this.state.geoLat ||
      this.state.LocationLat ||
      this.state.distance
    ) {
      var nearAsset = [];

      var data = {};
      data.CompanyId = this.state.companyId;
      data.SerchVehLat = this.state.vehicleLat;
      data.SerchVehLong = this.state.vehicleLng;
      data.geoFenceLat = this.state.geoLat;
      data.geoFenceLong = this.state.geoLng;
      data.LocationLat = this.state.LocationLat;
      data.LocationLong = this.state.LocationLong;
      data.mapClickLat = this.LiveTrackingStore.MapClickPoints?.lat
        ? this.LiveTrackingStore.MapClickPoints?.lat
        : null;
      data.mapClickLong = this.LiveTrackingStore.MapClickPoints?.lng
        ? this.LiveTrackingStore.MapClickPoints?.lng
        : null;
      data.distance = this.state.distance;
      if (this.state.companyId) {
        const response = await this.LiveTrackingStore.getNearestVehicleServ(
          data
        );

        nearAsset = response?.data?.data;
        console.log(nearAsset);
        var markerCar;
        nearAsset?.map((n) => {
          var popup = L.popup().setContent("vehicleNo =" + n.vehicleNo);
          markerCar = L.marker([Number(n.latitude), Number(n.longitude)])
            .setIcon(this.customIconFunc(n))
            .bindTooltip(
              "<div style='background:#00ff00;border:solid 1px #000;text-align:center;padding:0'><b>" +
                n.vehicleNo +
                "</b></div>",
              {
                permanent: true,
                direction: "bottom",
              }
            )
            .addTo(this.props.mapRef.current);
          this.state.markerShape.push(markerCar);
        });
        if (nearAsset?.length > 0) {
          this.props.mapRef.current.setView(
            [Number(nearAsset[0]?.latitude), Number(nearAsset[0]?.longitude)],
            14
          );
        } else {
          Modal.warning({
            title: this.context.translate("_FLEET_ALERT_"),
            content: this.context.translate("_VEHICLE_NOT_AVAILABLE_"),
          });
        }
      }
    }
  };
  handleCancel = async () => {
    var map = this.props.mapRef.current;
    if (this.state.ShapeValue.length > 0) {
      this.state.ShapeValue.map((s) => {
        map.removeLayer(s);
      });
    }
    if (this.state.markerShape.length > 0) {
      this.state.markerShape.map((m) => {
        map.removeLayer(m);
      });
    }
    if (
      this.LiveTrackingStore.Marker != undefined &&
      this.LiveTrackingStore.Marker != null &&
      this.LiveTrackingStore.Marker != ""
    ) {
      map.removeLayer(this.LiveTrackingStore.Marker);
    }
    await this.setState({
      companyId: null,
      vehicleLat: null,
      vehicleLng: null,
      geoLat: null,
      geoLng: null,
      LocationLat: null,
      LocationLong: null,
      distance: null,
      loadState: 1,
    });
    var arr = null;
    this.LiveTrackingStore.setOnMapClickPoints(arr);

    this.LiveTrackingStore.setShowNearVehiclePopup(false);

    this.LiveTrackingStore.setAutorunPopup(true);
  };
  handleVehicleChange = async (val, x) => {
    var selectedVehicle = (this.LiveTrackingStore?.veicleList?.filter(
      (vehicle) => {
        return val == vehicle.vehicleId;
      }
    ))[0];

    await this.setState({
      vehicleLat: selectedVehicle.latitude,
      vehicleLng: selectedVehicle.longitude,
      geoLat: null,
      geoLng: null,
      mapLat: null,
      mapLng: null,
      LocationLat: null,
      LocationLong: null,
    });
  };

  handleGeoFenceChange = async (val, x) => {
    console.log(val, x);
    console.log(this.LiveTrackingStore.GeofenceList);
    let getAllInfo = this.LiveTrackingStore?.GeofenceList?.filter((val2) => {
      return val2.zoneId === val;
    })[0];
    console.log(getAllInfo);

    console.log({ ...getAllInfo, points: getAllInfo?.points?.split(",") });
    this.props.getGeoFenceObj({
      ...getAllInfo,
      points: [getAllInfo?.points?.split(",")],
    });
    await this.setState({
      geoLat: parseFloat(getAllInfo.points.split(",")[0]),
      geoLng: parseFloat(getAllInfo.points.split(",")[1]),
      vehicleLat: null,
      vehicleLng: null,
      mapLat: null,
      mapLng: null,
      LocationLat: null,
      LocationLong: null,
    });
  };
  async handleChange(comp) {
    await this.setState({ companyId: comp.value });

    await this.LiveTrackingStore.loadData({
      offset: 0,
      limit: 5000,
      companyId: this.state.companyId,
      status: this.state.status,
      searchField: this.state.searchField,
    });

    await this.LiveTrackingStore.getVehicleData(this.state.companyId);
    this.setState({
      loadState: 1,
    });
  }

  onStart = async (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = this.dragRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    this.setState({
      bounds: {
        left: -targetRect.left + uiData.x,
        right: clientWidth - (targetRect.right - uiData.x),
        top: -targetRect.top + uiData.y,
        bottom: clientHeight - (targetRect.bottom - uiData.y),
      },
    });
  };
  async handleInput(event) {
    await this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleOptionChange = async (val, store) => {
    console.log(val);
    this.setState({ searchBy: val });
    var map = this.props.mapRef.current;
    var locationIcon = new Icon({
      // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
      iconUrl: require("../assets/images/location-pin.png"),
      iconSize: [38, 38], // size of the icon
    });
    if (this.state.markerShape.length > 0) {
      this.state.markerShape.map((m) => {
        map.removeLayer(m);
      });
    }

    if (val === "map") {
      this.setState({
        vehicleDisable: true,
        GeoDisable: true,
        LocDisable: true,
      });
      if (this.state.ShapeValue.length > 0) {
        this.state.ShapeValue.map((s) => {
          map.removeLayer(s);
        });
      }
      var mapLat;
      var mapLng;

      var theMarker = {};
      await map.on("click", (e) => {
        mapLat = e.latlng.lat;
        mapLng = e.latlng.lng;
        //  store.setOnMapClickPoints(mapLat,mapLng);
        var arr = {
          lat: mapLat,
          lng: mapLng,
        };
        console.log("in map");

        this.setState({ clickOnMapBoolean: false });
        if (theMarker != undefined && theMarker != null) {
          map.removeLayer(theMarker);
        }

        store.setOnMapClickPoints(arr);
        if (store.MapClickPoints) {
          theMarker = L.marker([
            store.MapClickPoints.lat,
            store.MapClickPoints.lng,
          ])
            .setIcon(locationIcon)
            .addTo(map);
        }
        store.setMarker(theMarker);
      });

      this.setState({
        geoLat: null,
        geoLng: null,
        vehicleLat: null,
        vehicleLng: null,
        LocationLat: null,
        LocationLong: null,
      });
    }

    if (val === "vehicle") {
      this.setState({
        vehicleDisable: false,
        GeoDisable: true,
        LocDisable: true,
      });
      if (this.state.ShapeValue.length > 0) {
        this.state.ShapeValue.map((s) => {
          map.removeLayer(s);
        });
      }
      if (
        this.LiveTrackingStore.Marker != undefined &&
        this.LiveTrackingStore.Marker != null &&
        this.LiveTrackingStore.Marker != ""
      ) {
        map.removeLayer(this.LiveTrackingStore.Marker);
      }
      this.setState({
        geoLat: null,
        geoLng: null,
      });
      var arr = null;
      this.LiveTrackingStore.setOnMapClickPoints(arr);
    }
    if (val === "geofence") {
      this.setState({
        vehicleDisable: true,
        GeoDisable: false,
        LocDisable: true,
      });

      if (
        this.LiveTrackingStore.Marker != undefined &&
        this.LiveTrackingStore.Marker != null &&
        this.LiveTrackingStore.Marker != ""
      ) {
        map.removeLayer(this.LiveTrackingStore.Marker);
      }
    }
    if (val === "location") {
      this.setState({
        vehicleDisable: true,
        GeoDisable: true,
        LocDisable: false,
      });

      if (this.state.ShapeValue.length > 0) {
        this.state.ShapeValue.map((s) => {
          map.removeLayer(s);
        });
      }
      if (
        this.LiveTrackingStore.Marker != undefined &&
        this.LiveTrackingStore.Marker != null &&
        this.LiveTrackingStore.Marker != ""
      ) {
        map.removeLayer(this.LiveTrackingStore.Marker);
      }
    }
  };
  handlePlaceSelected = async (place) => {
    console.log(place);
    const { address_components } = place;

    await this.setState({
      LocationLat: place.geometry.location.lat(),
      LocationLong: place.geometry.location.lng(),
      geoLat: null,
      geoLng: null,
      vehicleLat: null,
      vehicleLng: null,
      mapLat: null,
      mapLng: null,
    });
  };
  render() {
    return (
      <>
        <Draggable handle=".handle">
          <Card
            className="right-menu-panel headerGroup-panel"
            title={
              <div
                className="handle"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>{this.context.translate("_NEAREST_ASSET_")}</div>
                <CloseOutlined
                  onClick={() =>
                    this.props.handleCancel("showNearVehiclePopup")
                  }
                />
              </div>
            }
          >
            <Form
              name="control-hooks"
              layout="vertical"
              // onFinish={onFinish}
              style={{
                maxWidth: 600,
              }}
              ref={this.formRef}
            >
              {(this.props.getUserData().isadmin === -1 ||
                this.props.getUserData().isadmin === 3) && (
                <Form.Item
                  name="Select Account"
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_DASHBORD_NEWPOI_CUSTOMER_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  style={{ marginBottom: "2px", marginTop: "2px" }}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CompanyAutocomplete
                    onChange={(value) => {
                      this.handleChange(value);
                      this.formRef.current.setFieldsValue({
                        SelectVehicle: null,
                        SelectGeofence: null,
                      });
                    }}
                  />
                </Form.Item>
              )}
              <Form.Item
                name="Search"
                label={
                  <span>
                    {this.context.translate("_SEARCHBY_")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                required={false}
                style={{ marginBottom: "2px", marginTop: "2px" }}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder="Search"
                  onSelect={async (e) =>
                    await this.handleOptionChange(e, this.LiveTrackingStore)
                  }
                  options={[
                    {
                      value: "vehicle",
                      label: this.context.translate("_VEHICLE_NO_"),
                      // label: 'Vehicle No',
                    },
                    {
                      value: "geofence",
                      // label: 'Geofence',
                      label: this.context.translate("_GEOFENCE_"),
                    },
                    {
                      value: "location",
                      // label: 'Location',
                      label: this.context.translate(
                        "_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"
                      ),
                    },
                    {
                      value: "map",
                      // label: 'Click on Map',
                      label: this.context.translate("_CLICK_ON_MAP_"),
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="SelectVehicle"
                style={{ marginBottom: "2px", marginTop: "2px" }}
                label={
                  <span>
                    {this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                    )}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                required={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  //showSearch
                  // placeholder="Select Vehicle"
                  placeholder={this.context.translate("_SELECT_VEHICLE_")}
                  // onChange={(a,b)=>console.log(a,b)}
                  onSelect={this.handleVehicleChange}
                  disabled={this.state.vehicleDisable}
                  filterOption={(inputValue, option) => {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }}
                >
                  {this.LiveTrackingStore?.veicleList?.map((vehicle) => {
                    return (
                      <Option
                        key={vehicle.vehicleId}
                        value={parseInt(vehicle.vehicleId)}
                        // value={vehicle}
                      >
                        {vehicle.vehicleNo}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item
                name="SelectGeofence"
                style={{ marginBottom: "2px", marginTop: "2px" }}
                label={
                  <span>
                    {this.context.translate(
                      "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                    )}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                required={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  //showSearch
                  // placeholder="Select Geofence"
                  placeholder={this.context.translate(
                    "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                  )}
                  // onChange={(a,b)=>console.log(a,b)}
                  onSelect={this.handleGeoFenceChange}
                  disabled={this.state.GeoDisable}
                  filterOption={(inputValue, option) => {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }}
                >
                  {this.LiveTrackingStore?.GeofenceList?.map((Geo) => {
                    return (
                      <Option
                        key={Geo.zoneId}
                        value={parseInt(Geo.zoneId)}

                        // value={vehicle}
                      >
                        {Geo.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item
                // label="Enter Location"
                label={this.context.translate("_ENTER_LOCATION_")}
                style={{ marginBottom: "2px", marginTop: "2px" }}
              >
                <Autocomplete
                  style={{
                    background: this.state.LocDisable ? "#cbcbcb2b" : "white",
                    border: "solid 1px #CBCBCB",
                    borderRadius: "5px",
                    width: "100%",
                    padding: "0 10px",
                    height: "40px",
                  }}
                  className="autocomplete-location-textbox"
                  disabled={this.state.LocDisable}
                  apiKey={config.googleMapKey}
                  componentRestrictions={{ country: "us" }}
                  options={{
                    types: ["geocode", "establishment"],
                  }}
                  onPlaceSelected={(val) => {
                    this.setState({ formatted_address: val.formatted_address });
                    this.handlePlaceSelected(val);
                  }}
                />
              </Form.Item>

              <Form.Item
                name="Distance"
                style={{ marginBottom: "2px", marginTop: "2px" }}
                label={
                  <span>
                    {this.context.translate("_ENTER_DISTANCE_")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                required={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  name="distance"
                  // placeholder="Enter Distance"
                  placeholder={this.context.translate("_ENTER_DISTANCE_")}
                  onChange={this.handleInput}
                />
              </Form.Item>
            </Form>

            <div className="formBtnGroup">
              <Button
                className="formCancelButton"
                onClick={() => this.props.handleCancel("showNearVehiclePopup")}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}{" "}
              </Button>
              <Button
                className="formSaveButton"
                type="primary"
                onClick={this.handleOk}
              >
                {this.context.translate("_SEARCH_")}
              </Button>
            </div>
          </Card>
        </Draggable>
      </>
    );
  }
}

DraggableModal.contextType = StoreContext;
export default observer(withRouter(DraggableModal));
